module.exports = __webpack_public_path__ + "assets/img/home.0dd63428.png";